import * as types from "./types";

export default {
  [types.PLANNED_OKR_TOTALIZER]: (state) => {
    return state.plannedOkrTotalizer;
  },
  [types.PLANNED_OKR_LIST]: (state) => {
    return state.plannedOkrList;
  },
  [types.OKR_OVERVIEW_TOTALIZER]: (state) => {
    return state.okrOverviewTotalizer;
  },
  [types.OKR_OVERVIEW_LIST]: (state) => {
    return state.okrOverviewList;
  },
  [types.HISTORICAL_PERFORMANCE]: (state) => state.historicalPerformance,
};
